import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCellClick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.12541 8.55645L7.59152 7.85979C8.22896 7.54312 8.48393 6.84646 8.2927 6.21314L6.38038 0.956528C6.25289 0.5132 5.87043 0.196536 5.36048 0.069871C3.70314 -0.18346 2.36452 0.259869 1.28087 1.27319C0.388455 2.09652 -0.0577523 3.17317 0.00599165 4.37649C0.515943 12.8631 10.2688 22.4896 18.7467 22.9963C19.9578 23.123 21.0415 22.6796 21.9339 21.793C22.9538 20.7163 23.4 19.3863 23.0813 17.6763C23.0175 17.233 22.6988 16.853 22.1889 16.663L16.8981 14.8264C16.2607 14.573 15.5595 14.8897 15.2408 15.523L14.6033 16.9164C10.715 15.523 7.59152 12.3564 6.12541 8.55645Z"
	})
});
export default SvgCellClick;
